import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { ContentWrapper } from "@components/index";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { useNotification } from "~/Hooks/useNotification";
import { post, put } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { DocumentDetailsResponse, useDocumentDetails } from "../ApprovalManagement/Drilldown.Hooks";
import { fields } from "./constants";
import { Announcement, useAnnouncementDetails } from "./helper";
import { magpHost } from "~/Utils";

export const AddEditAnnouncement = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { id, type } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("Tender");

  let annData: DocumentDetailsResponse | undefined = undefined;
  let announcementData: Announcement | undefined = undefined;
  let isLoadingAnn = false;
  let isLoadingData = false;
  let refetchingData: (() => void) | undefined = undefined;
  let refetchingDocument: (() => void) | undefined = undefined;

  if (type === "status") {
    const { data: annnData, isLoading: isLoadingAnnn, refetch: refetchDocument } = useDocumentDetails(id || "");
    annData = annnData;
    isLoadingAnn = isLoadingAnnn;
    refetchingDocument = refetchDocument;
  } else {
    const {
      data: announcementsData,
      isLoading: isLoadingAnnouncementData,
      refetch: refetchData,
    } = useAnnouncementDetails(id || "");
    announcementData = announcementsData;
    isLoadingData = isLoadingAnnouncementData;
    refetchingData = refetchData;
  }
  console.log("announcement", announcementData, annData);

  useEffect(() => {
    if (id && type === "status") {
      refetchingDocument();
    } else {
      refetchingData();
    }
  }, []);

  // useEffect(() => {
  //   if (type === "status" && refetchingDocument) {
  //     refetchingDocument();
  //   } else if (refetchingData) {
  //     refetchingData();
  //   }
  // }, []);

  // useEffect(() => {
  //   if (id && type === 'status' && refetchingDocument) {
  //     refetchingDocument();
  //   } else if (refetchingData) {
  //     refetchingData();
  //   }
  // }, [id, type]);

  const { openToast } = useNotification();
  // const [announcementData, setData] = useState<Announcements>();

  const initialValues = {
    field_tender_calling_date:
      annData?.payload && annData?.payload?.field_tender_calling_date
        ? moment(annData?.payload?.field_tender_calling_date, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD")
        : announcementData?.field_tender_calling_date
          ? moment(announcementData?.field_tender_calling_date, "DD MMM YYYY").format("YYYY-MM-DD")
          : "",
    field_tender_closing_date:
      annData?.payload && annData?.payload?.field_tender_closing_date
        ? moment(annData?.payload?.field_tender_closing_date, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD")
        : announcementData?.field_tender_closing_date
          ? moment(announcementData?.field_tender_closing_date, "DD MMM YYYY").format("YYYY-MM-DD")
          : "",
    field_tender_content: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_content?.value)
      : decodeHTML(announcementData?.field_tender_content),
    field_tender_content_ms: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_content_ms?.value)
      : decodeHTML(announcementData?.field_tender_content_ms),
    field_tender_content_zh: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_content_zh?.value)
      : decodeHTML(announcementData?.field_tender_content_zh),
    // field_tender_main_heading: annData?.payload
    //   ? decodeHTML(annData?.payload?.field_tender_main_heading)
    //   : decodeHTML(announcementData?.field_tender_main_heading),
    // field_tender_main_heading_ms: annData?.payload
    //   ? decodeHTML(annData?.payload?.field_tender_main_heading_ms)
    //   : decodeHTML(announcementData?.field_tender_main_heading_ms),
    // field_tender_main_heading_zh: annData?.payload
    //   ? decodeHTML(annData?.payload?.field_tender_main_heading_zh)
    //   : decodeHTML(announcementData?.field_tender_main_heading_zh),
    field_tender_pre_heading_en: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_pre_heading_en)
      : decodeHTML(announcementData?.field_tender_pre_heading_en),
    field_tender_pre_heading_ms: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_pre_heading_ms)
      : decodeHTML(announcementData?.field_tender_pre_heading_ms),
    field_tender_pre_heading_zh: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_pre_heading_zh)
      : decodeHTML(announcementData?.field_tender_pre_heading_zh),
    field_tender_remark: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_remark)
      : decodeHTML(announcementData?.field_tender_remark),
    field_tender_remark_ms: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_remark_ms)
      : decodeHTML(announcementData?.field_tender_remark_ms),
    field_tender_remark_zh: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_remark_zh)
      : decodeHTML(announcementData?.field_tender_remark_zh),
    field_tender_time: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_time)
      : decodeHTML(announcementData?.field_tender_time),
    field_tender_venue: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_venue)
      : decodeHTML(announcementData?.field_tender_venue),
    field_tender_venue_ms: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_venue_ms)
      : decodeHTML(announcementData?.field_tender_venue_ms),
    field_tender_venue_zn: annData?.payload
      ? decodeHTML(annData?.payload?.field_tender_venue_zn)
      : decodeHTML(announcementData?.field_tender_venue_zn),
    published: annData?.payload 
      ? decodeHTML(annData?.payload?.published)
      : decodeHTML(announcementData?.published)
  };

  const formConfig: FormConfig = {
    initialValues: initialValues,
    fields: fields.tender,
  };

  // const getRecords = () => {
  //   setIsLoading(true);
  //   let url = `${magpHost}/api/tender-details/all-fields`;
  //   axios
  //     .get<Announcements>(url, { params: { id: id } })
  //     .then((res) => {
  //       if (res && res.data) {
  //         setData(res.data);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //
  //       setIsLoading(false);
  //     });
  // };

  useEffect(() => {
    if (id && type === "cms") {
      setTitle("Edit Tender");
      // getRecords();
    } else {
      setTitle("Add Tender");
    }
  }, []);

  useEffect(() => {
    if (type === "status") {
      if (annData?.action === "CREATE") {
        setTitle("Add Tender");
      } else {
        setTitle("Edit Tender");
      }
    }
  }, [annData]);

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    // let imageKeys: any = [
    //   "fbImage",
    //   "field_purchase_login_pop_image",
    //   "field_login_image",
    //   "filledImage",
    //   "googleImage",
    //   "showImage",
    //   "field_logout_image",
    // ];
    // for (const key of imageKeys) {
    //   try {
    //     let field = data[key];
    //     if (field[0].originFileObj) {
    //       const formData = new FormData();
    //       formData.append("upload-file", field[0].originFileObj);
    //       formData.append("application", "MAGP");
    //       const res: any = await post("management/upload-file", formData);
    //
    //       if (res) {
    //         data[key] = res.response.data;
    //       }
    //     } else {
    //       data[key] = data[key][0].url;
    //     }
    //   } catch (error) {
    //
    //   }
    // }

    let timeKeys: any =[
      "field_tender_time"
    ]
    for (const key of timeKeys) {
      try {
        data[key] = data[key] ? data[key] : ""; //new Date().toISOString()
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "ANNOUNCEMENT",
      subModule: "tender",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        id: data?.id || announcementData?.id || annData?.payload?.id,
        field_tender_content: {
          value: data?.field_tender_content || "",
          format: "full_html",
        },
        field_tender_content_ms: {
          value: data?.field_tender_content_ms || "",
          format: "full_html",
        },
        field_tender_content_zh: {
          value: data?.field_tender_content_zh || "",
          format: "full_html",
        },
        // field_tender_content: data?.field_tender_content || announcementData?.field_tender_content || annData?.payload?.field_tender_content,
        // field_tender_content_ms: data?.field_tender_content_ms || announcementData?.field_tender_content_ms || annData?.payload?.field_tender_content_ms,
        // field_tender_content_zh: data?.field_tender_content_zh || announcementData?.field_tender_content_zh || annData?.payload?.field_tender_content_zh,
        field_tender_main_heading: data?.field_tender_pre_heading_en || "",
        field_tender_main_heading_ms: data?.field_tender_pre_heading_ms || "",
        field_tender_main_heading_zh: data?.field_tender_pre_heading_zh || "",
        field_tender_pre_heading_en: data?.field_tender_pre_heading_en || "",
        field_tender_pre_heading_ms: data?.field_tender_pre_heading_ms || "",
        field_tender_pre_heading_zh: data?.field_tender_pre_heading_zh || "",
        field_tender_remark: data?.field_tender_remark || "",
        field_tender_remark_ms: data?.field_tender_remark_ms || "",
        field_tender_remark_zh: data?.field_tender_remark_zh || "",
        field_tender_time: data?.field_tender_time || "",
        field_tender_venue: data?.field_tender_venue || "",
        field_tender_venue_ms: data?.field_tender_venue_ms || "",
        field_tender_venue_zn: data?.field_tender_venue_zn || "",
        field_tender_created_by:
          method === "POST"
            ? user.email
            : announcementData?.field_tender_created_by
              ? announcementData?.field_tender_created_by
              : annData?.payload?.field_tender_created_by
                ? annData?.payload?.field_tender_created_by
                : "Drupal Admin",
        field_tender_updated_by: user.email,
        published: data?.published === true ? true: false,
        field_tender_calling_date: data.field_tender_calling_date
          ? data.field_tender_calling_date
          : "",
        field_tender_closing_date: data.field_tender_closing_date
          ? data.field_tender_closing_date
          : "",
      },
      status: status,
    };

    if (type === "status") {
      put(`/management/update-document?approvalId=${id}`, payload)
        .then((response:any) => {
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (refetchingDocument) refetchingDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          if (refetchingDocument) refetchingDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={title}
      showBack
    >
      <div>
        <DynamicForm
          isLoading={isLoadingData || isLoadingAnn}
          config={formConfig}
          onSubmit={(data, buttonValue, reviewNotes) => {
            if (id) {
              if (type === "status" && annData) {
                onSubmit(
                  data,
                  `${magpHost}/api/tender-creation/${id}`,
                  annData.action,
                  annData.method,
                  buttonValue == "save" ? "DRAFT" : "PENDING",
                  reviewNotes
                );
              } else {
                announcementData &&
                  onSubmit(
                    data,
                    `${magpHost}/api/tender-creation/${id}`,
                    "UPDATE",
                    "PATCH",
                    buttonValue == "save" ? "DRAFT" : "PENDING",
                    reviewNotes
                  );
              }
            } else {
              onSubmit(
                data,
                `${magpHost}/api/tender-creation`,
                "CREATE",
                "POST",
                buttonValue == "save" ? "DRAFT" : "PENDING",
                reviewNotes
              );
            }
          }}
        />
      </div>
    </ContentWrapper>
  );
};
